export default __webpack_public_path__ + "static/hero-image-1-edd2677d04b2ca19bec11bab0474f4d5.jpeg";